import { MODAL_TYPES } from "../config/MODAL_TYPES";
import ProveedorFormModal from "./ProveedorFormModal";
import SucursalesProveedorModal from "./SucursalesProveedorModal";

const ModalManager = ({ modal, onClose, refresh, showToast }) => {
  if (!modal) return null;

  switch (modal.type) {
    case MODAL_TYPES.FORM:
      return (
        <ProveedorFormModal
          open
          onClose={onClose}
          proveedor={modal.proveedor}
          refresh={refresh}
          showToast={showToast}
        />
      );

    case MODAL_TYPES.SUCURSALES:
      return (
        <SucursalesProveedorModal
          open
          onClose={onClose}
          proveedor={modal.proveedor}
          showToast={showToast}
        />
      );

    default:
      return null;
  }
};

export default ModalManager;
